import { render, staticRenderFns } from "./ChatbotChat.vue?vue&type=template&id=842280f0&scoped=true"
import script from "./ChatbotChat.vue?vue&type=script&lang=js"
export * from "./ChatbotChat.vue?vue&type=script&lang=js"
import style0 from "./ChatbotChat.vue?vue&type=style&index=0&id=842280f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842280f0",
  null
  
)

export default component.exports